import React from 'react';
import { LinkedinIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ucensys-navy border-t border-border-color pt-20 pb-10" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-15">
          {/* Company Info */}
          <div className="space-y-6" data-id="element-16">
            <a href="#" className="flex items-center gap-2" data-id="element-17">
              <span className="text-2xl font-heading font-bold text-ucensys-teal" data-id="element-18">
                U|
              </span>
              <span className="text-xl font-heading font-semibold text-white tracking-tight" data-id="element-19">
                Ucensys
              </span>
            </a>
            <p className="text-text-secondary font-body text-sm leading-relaxed" data-id="element-20">
              Innovating Solutions for a Better Tomorrow. Advancing Artificial
              Intelligence and Delivering Breakthroughs from our historic
              Atlanta facility.
            </p>
            <div className="flex items-center gap-4" data-id="element-21">
              <a href="https://linkedin.com/company/ucensys-research" target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-ucensys-teal transition-colors" data-id="element-22">
                <LinkedinIcon className="w-5 h-5" data-id="element-23" />
                <span className="sr-only" data-id="element-24">LinkedIn</span>
              </a>
              <a href="#" className="text-text-muted hover:text-ucensys-teal transition-colors" data-id="element-25">
                <YoutubeIcon className="w-5 h-5" data-id="element-26" />
                <span className="sr-only" data-id="element-27">YouTube</span>
              </a>
            </div>
          </div>

          {/* Services Links */}
          <div data-id="element-28">
            <h3 className="text-white font-heading font-semibold mb-6" data-id="element-29">
              Services
            </h3>
            <ul className="space-y-4" data-id="element-30">
              <li data-id="element-31">
                <a href="#services" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-32">
                  Hybrid Cloud Solutions
                </a>
              </li>
              <li data-id="element-33">
                <a href="#ai-ml" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-34">
                  AI & ML Infrastructure
                </a>
              </li>
              <li data-id="element-35">
                <a href="#services" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-36">
                  Colocation Services
                </a>
              </li>
              <li data-id="element-37">
                <a href="#services" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-38">
                  Data Storage & Backup
                </a>
              </li>
              <li data-id="element-39">
                <a href="#services" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-40">
                  Multi-Cloud Management
                </a>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div data-id="element-41">
            <h3 className="text-white font-heading font-semibold mb-6" data-id="element-42">
              Company
            </h3>
            <ul className="space-y-4" data-id="element-43">
              <li data-id="element-44">
                <a href="#about" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-45">
                  About Us
                </a>
              </li>
              <li data-id="element-46">
                <a href="#data-center" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-47">
                  Our Facility
                </a>
              </li>
              <li data-id="element-48">
                <a href="#partners" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-49">
                  Partners
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-51">
                  Careers
                </a>
              </li>
              <li data-id="element-52">
                <a href="#contact" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-53">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-54">
            <h3 className="text-white font-heading font-semibold mb-6" data-id="element-55">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-56">
              <li className="text-text-secondary text-sm font-body" data-id="element-57">
                Downtown Atlanta
                <br data-id="element-58" />
                Historic Financial District
                <br data-id="element-59" />
                Atlanta, GA
              </li>
              <li data-id="element-60">
                <a href="mailto:info@ucensys.com" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-61">
                  info@ucensys.com
                </a>
              </li>
              <li data-id="element-62">
                <a href="tel:+18005550199" className="text-text-secondary hover:text-ucensys-teal transition-colors text-sm font-body" data-id="element-63">
                  +1 (800) 555-0199
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border-color flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-64">
          <p className="text-text-muted text-sm font-body" data-id="element-65">
            © 2026 Ucensys. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-66">
            <a href="#" className="text-text-muted hover:text-white transition-colors text-sm font-body" data-id="element-67">
              Privacy Policy
            </a>
            <a href="#" className="text-text-muted hover:text-white transition-colors text-sm font-body" data-id="element-68">
              Terms of Service
            </a>
            <a href="#" className="text-text-muted hover:text-white transition-colors text-sm font-body" data-id="element-69">
              SLA
            </a>
          </div>
        </div>
      </div>
    </footer>;
}